import { Default } from "../../components/default/Default";
import { useNavigate } from "react-router-dom";

const ChevronLeftIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m15 6-6 6 6 6" />
  </svg>
);

const BellIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6Z" />
    <path d="M10.5 20a2 2 0 0 0 3 0" />
  </svg>
);

const ComingSoonStyles = () => {
  const styles = `
    .cs-wrap { 
      min-height: calc(100vh - var(--mca-topbar-h) - 64px); 
      display: grid; 
      place-items: center; 
    }
    .cs { 
      text-align: center; 
      max-width: 460px; 
      padding: 24px; 
    }
    .cs__mark { 
      width: 96px; 
      height: 96px; 
      margin: 0 auto 24px; 
      border-radius: var(--mca-radius-2xl); 
      background: var(--mca-primary-subtle-bg); 
      display: grid; 
      place-items: center; 
      position: relative; 
      overflow: hidden; 
    }
    .cs__mark::before { 
      content: ""; 
      position: absolute; 
      inset: 0; 
      background-image: url("/assets/brand/NoisePattern.svg"); 
      background-size: 180px; 
      opacity: .5; 
      mix-blend-mode: multiply; 
    }
    [data-bs-theme="dark"] .cs__mark::before { 
      background-image: url("/assets/brand/NoisePatternLight.svg"); 
      mix-blend-mode: screen; 
      opacity: .3; 
    }
    .cs__mark img { 
      width: 52px; 
      height: 52px; 
      position: relative; 
      z-index: 1;
    }
    .cs h1 { 
      font-size: 28px; 
      font-weight: 700; 
      letter-spacing: -0.02em; 
      margin: 0 0 10px 0;
    }
    .cs p { 
      color: var(--mca-muted); 
      font-size: 15px; 
      line-height: 1.6; 
      margin: 10px 0 24px; 
    }
    .cs__actions { 
      display: flex; 
      gap: 10px; 
      justify-content: center; 
      flex-wrap: wrap; 
    }
  `;
  return <style>{styles}</style>;
};

export const ComingSoon = () => {
  const navigate = useNavigate();

  const handleNotifyClick = () => {
    const message = "We'll email you when it ships.";
    const event = new CustomEvent("mcaToast", {
      detail: {
        message,
        type: "info",
      },
    });
    window.dispatchEvent(event);
  };

  const handleBackClick = () => {
    navigate("/");
  };

  return (
    <Default>
      <ComingSoonStyles />
      <div className="mca-content cs-wrap">
        <div className="cs">
          <div className="cs__mark">
            <img src="/assets/brand/mca-mark.png" alt="MultiCartAPI" />
          </div>
          <span
            className="mca-badge mca-badge--soft-primary"
            style={{ marginBottom: "14px" }}
          >
            Coming soon
          </span>
          <h1>Destinations</h1>
          <p>
            Auto-deliver your collection results to S3, FTP, or a webhook the
            moment a run completes. We're putting the finishing touches on it.
          </p>
          <div className="cs__actions">
            <button
              className="mca-btn mca-btn--primary"
              onClick={handleBackClick}
            >
              <ChevronLeftIcon />
              Back to dashboard
            </button>
            <button
              className="mca-btn mca-btn--outline"
              onClick={handleNotifyClick}
            >
              <BellIcon />
              Notify me
            </button>
          </div>
        </div>
      </div>
    </Default>
  );
};
